module.exports = __webpack_public_path__ + "static/media/cloud-snow.8ea9bcae.svg";